import { AddressLinkType } from 'Modules'

import { BASE_SCAN } from 'constants/index'
import { getIpfsGatewayBaseUrl } from 'stores/setting.store'
import { randomInt } from 'utils/random'

export const rendererCountDown2 = ({ days, hours, minutes, seconds, completed }: any) => {
  // Render a countdown
  if (completed) {
    return <span>Unstakeable Now</span>
  }
  if (days > 1) {
    return (
      <span className="status-success">
        {days} days : {hours} h : {minutes} m : {seconds} s
      </span>
    )
  } else if (days === 1) {
    return (
      <span className="status-success">
        {days} day : {hours} h : {minutes} m : {seconds} s
      </span>
    )
  } else {
    return (
      <span className="status-success">
        {hours} h : {minutes} m : {seconds} s
      </span>
    )
  }
}

export const renderAddressUrl = (address: string, type: AddressLinkType = 'address') => {
  if (!address) return '/'
  return `${BASE_SCAN}/${type}/${address}`
}

export const generateRandomPassword = (length = 10) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()'
  return Array.from({ length }, () => chars[randomInt(chars.length)]).join('')
}

export const generateIpfsUrl = (
  uri: string | null | undefined,
  gateway = getIpfsGatewayBaseUrl()
): string | null => {
  if (!uri) return ''

  const trimmed = uri.trim()

  // Nếu đã là link gateway hợp lệ
  if (trimmed.startsWith(gateway)) {
    return trimmed || ''
  }

  // Nếu là ipfs://CID thì chuyển sang gateway
  if (trimmed.startsWith('ipfs://')) {
    const cid = trimmed.slice(7)
    if (!cid || /[^a-z0-9]/i.test(cid)) return '' // CID đơn giản validation
    return `${gateway}${cid}`
  }
  // Không hợp lệ
  return `${gateway}${uri}`
}
